/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-03 00:00:00
 *
 *******************************************************/
import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FullscreenBar, Tooltip, Icon } from '@shopify/polaris';
import {
  DesktopMajor,
  // MobileMajor,
  ExitMajor
} from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

import {
  enterSABFullscreen,
  exitSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';
import { handleOpenFullscreen } from 'actions/app-integration-actions';

import { DEVICE } from 'src/constants/theme-settings';

import PreviewDefaultTemplate from 'src/assets/images/shopify-integration/PreviewDefaultTemplate.png';
import PreviewBasicTemplate from 'src/assets/images/shopify-integration/PreviewBasicTemplate.png';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class PreviewBoostTemplate extends Component<ComposedProps, State> {
  unsubscribeExit = undefined;
  state = {
    selectedDevice: DEVICE.DESKTOP
  };

  componentDidMount() {
    // Open fullscreen
    this.handleOpenFullscreenPage();
  }

  componentWillReceiveProps(nextProps) {}

  componentWillUnmount() {
    this.unsubscribeExit();
  }

  render() {
    const { i18n } = this.props;
    const { selectedDevice } = this.state;
    const themeNameLib = _.get(this.props.match.params, 'themeNameLib', '');

    const devices = [
      {
        id: DEVICE.DESKTOP,
        content: <Icon source={DesktopMajor} color="base" />,
        panelID: DEVICE.DESKTOP
      },
      // {
      //   id: DEVICE.MOBILE,
      //   content: <Icon source={MobileMajor} color="base" />,
      //   panelID: DEVICE.MOBILE
      // }
    ];

    const previewImage = {
      default: PreviewDefaultTemplate,
      basic: PreviewBasicTemplate
    };

    return (
      <div className="BC-ThemeSetting-Editor-Page theme-setting-visual-editor shopify-integration-preview">
        <FullscreenBar>
          <button
            className="BC-BackAction Polaris-FullscreenBar__BackAction"
            onClick={this.handleCloseEditor}>
            <Tooltip
              content={i18n.translate('AdminHTML.ThemeSetting.Common.exit')}
              zIndexOverride="520">
              <Icon source={ExitMajor} color="base" />
            </Tooltip>
          </button>
          <div className="visual-editor-header">
            <div className="theme-name">
              <p>{_.upperFirst(themeNameLib)}</p>
            </div>
            <div className="theme-preview shopify-integration">
              <div className="select-theme-preview">
                <ul className="Polaris-Tabs Polaris-Tabs--fillSpace">
                  {devices.map(item => {
                    return (
                      <li
                        className="Polaris-Tabs__TabContainer"
                        key={item.id}
                        onClick={() => this.handleChangeDevice(item.id)}>
                        <button
                          className={`Polaris-Tabs__Tab ${
                            selectedDevice === item.id ? 'Polaris-Tabs__Tab--selected' : ''
                          }`}>
                          <span
                            className="Polaris-Tabs__Title"
                            style={item.id === DEVICE.FULLSCREEN ? { height: '36px' } : {}}>
                            {item.content}
                          </span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="visual-editor-header__action"></div>
          </div>
        </FullscreenBar>
        <div className="visual-editor-body">
          <img className="preview-image" src={previewImage[themeNameLib]} alt="" />
        </div>
      </div>
    );
  }

  handleOpenFullscreenPage = () => {
    const { handleOpenFullscreen } = this.props;
    this.unsubscribeExit = enterSABFullscreen(this.handleCloseEditor);
    handleOpenFullscreen(true);
  };

  handleChangeDevice = deviceId => {
    this.setState({ selectedDevice: deviceId });
  };

  handleCloseEditor = () => {
    const { handleOpenFullscreen } = this.props;
    exitSABFullscreen();
    handleOpenFullscreen(false);

    history.push({ pathname: routes.shopifyIntegration.view() });
  };
}

const mapStateToProps = (state, props) => {
  return {};
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  handleOpenFullscreen: isOpenFullScreen => dispatch(handleOpenFullscreen(isOpenFullScreen))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(PreviewBoostTemplate));
